import React from "react";

function HealthInsuranceIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M32 0C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8C0 3.58172 3.58172 0 8 0H32Z"
        fill="url(#paint0_linear_1379_13654)"
      />
      <path
        d="M32 0C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8C0 3.58172 3.58172 0 8 0H32Z"
        stroke="#E5E7EB"
      />
      <path
        d="M18.7016 30.0132L10.2312 22.1054C10.0344 21.9226 9.84688 21.7257 9.67344 21.5242H13.7516C14.8109 21.5242 15.7672 20.8867 16.175 19.907L16.6672 18.7257L18.9781 23.8586C19.1562 24.257 19.5453 24.5148 19.9813 24.5195C20.4172 24.5242 20.8156 24.2851 21.0125 23.8961L23 19.9164L23.0797 20.0757C23.525 20.9664 24.4344 21.5289 25.4281 21.5289H30.3266C30.1531 21.7304 29.9656 21.9273 29.7687 22.1101L21.2984 30.0132C20.9469 30.3414 20.4828 30.5242 20 30.5242C19.5172 30.5242 19.0531 30.3414 18.7016 30.0132ZM31.6109 19.2742H25.4234C25.2828 19.2742 25.1516 19.1945 25.0859 19.0679L23.9984 16.8976C23.8062 16.5179 23.4172 16.2742 22.9906 16.2742C22.5641 16.2742 22.175 16.5132 21.9828 16.8976L20.0422 20.7789L17.6516 15.4398C17.4688 15.032 17.0562 14.7695 16.6109 14.7789C16.1656 14.7882 15.7625 15.0554 15.5891 15.4726L14.0984 19.0492C14.0422 19.1898 13.9016 19.2789 13.7516 19.2789H8.75C8.62813 19.2789 8.51562 19.2976 8.40781 19.3304C8.14062 18.5804 8 17.7836 8 16.9726V16.7007C8 13.4242 10.3672 10.6304 13.5969 10.0914C15.7344 9.73511 17.9094 10.4336 19.4375 11.9617L20 12.5242L20.5625 11.9617C22.0906 10.4336 24.2656 9.73511 26.4031 10.0914C29.6328 10.6304 32 13.4242 32 16.7007V16.9726C32 17.7648 31.8688 18.5429 31.6109 19.2742Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1379_13654"
          x1="0"
          y1="20"
          x2="40"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2563EB" />
          <stop offset="1" stop-color="#7C3AED" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default HealthInsuranceIcon;
